import SparkMD5 from 'spark-md5'
import JSZip from 'jszip'
import X2JS from 'x2js'
import XLSX from 'xlsx'
import { Message } from 'element-ui'
import { getCADVersionMap, getRevitVersionMap, getFileTypes } from '../assets/js/resourceMap'
import DxfParser from 'dxf-parser'

/** ----文件解压、解析等方法----*/
export default {
  install(Vue) {
    // 获取文件的MD5
    Vue.prototype.$getMd5 = function (file) {
      return new Promise((resolve, reject) => {
        const blobSlice =
          File.prototype.slice ||
          File.prototype.mozSlice ||
          File.prototype.webkitSlice
        const spark = new SparkMD5.ArrayBuffer()
        const chunkSize = 1024 * 1024
        // 如果是压缩文件，则从解压后的_data.uncompressedSize中获得size
        // const fileSize = size || file.size
        const chunks = Math.ceil(file.size / chunkSize)
        const fileReader = new FileReader()
        let currentChunk = 0
        const loadNext = () => {
          var start = currentChunk * chunkSize
          var end = start + chunkSize >= file.size ? file.size : start + chunkSize
          fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
        }
        fileReader.onload = (e) => {
          spark.append(e.target.result)
          currentChunk++
          if (currentChunk < chunks) {
            loadNext()
          } else {
            const md5 = spark.end()
            spark.destroy()
            resolve(md5)
          }
        }
        fileReader.onerror = () => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('error reading file to calculate md5')
        }
        loadNext()
      })
    }

    // 利用jszip压缩文件
    Vue.prototype.$zip = function (files) {
      return new Promise((resolve, reject) => {
        const JsZip = new JSZip()
        // 用于存储所有文件夹路径
        const folderPaths = new Set()
        let folderName
        // 遍历文件夹中的文件
        for (const file of files) {
          // console.log(file, '==')
          // 保持文件夹结构
          const relativePath = file.webkitRelativePath
          if (!folderName) {
            folderName = file.webkitRelativePath.split('/')[0]
          }
          JsZip.file(relativePath, file)
          // 提取所有父文件夹路径
          let currentPath = relativePath
          while (currentPath.includes('/')) {
            currentPath = currentPath.substring(0, currentPath.lastIndexOf('/'))
            folderPaths.add(currentPath)
          }
        }
        // 添加空文件夹
        folderPaths.forEach((folderPath) => {
          if (!JsZip.folder(folderPath)) {
            // 如果文件夹不存在，则创建
            JsZip.folder(folderPath)
          }
        })
        // 生成 ZIP 文件
        JsZip.generateAsync({ type: 'blob' }).then(function (zipFile) {
          // // 下载 ZIP 文件
          // const link = document.createElement('a')
          // link.href = URL.createObjectURL(zipFile)
          // link.download = `${folderName}.zip`
          // link.click()
          // URL.revokeObjectURL(link.href)
          //
          // console.log('文件夹压缩完成')
          resolve(zipFile)
        }).catch(() => {
          resolve(false)
        })
      })
    }

    // 利用jszip解压文件
    Vue.prototype.$unzip = function (zip) {
      return new Promise((resolve, reject) => {
        const JsZip = new JSZip()
        const iconv = require('iconv-lite')
        JsZip.loadAsync(zip, {
          decodeFileName: function (bytes) {
            return iconv.decode(bytes, 'gbk')
          }
        }).then(function (unzip) {
          resolve(unzip.files)
        }).catch(() => {
          resolve(false)
        })
      })
    }

    // 利用js-xlsx解析xlsx文件
    Vue.prototype.$analysisXLSX = function (xlsx) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = function (e) {
          const data = e.target.result
          const wb = XLSX.read(data, {
            type: 'binary',
            cellNF: true,
            raw: true
          })
          if (wb.SheetNames.length) {
            const result = []
            wb.SheetNames.forEach((sheetName) => {
              result.push({
                sheetName,
                sheet: XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { raw: true })
              })
            })
            resolve(result)
          } else {
            resolve({})
          }
        }
        fileReader.readAsBinaryString(xlsx)
      })
    }

    // 解压gac文件，并解析xml文件（默认自动识别xml中的分类信息）
    Vue.prototype.$getGacJson = function (gac, xmlFileName = 'CustomData/FamilyParameters.xml') {
      return new Promise((resolve, reject) => {
        const JsZip = new JSZip()
        JsZip.loadAsync(gac).then(function (zip) {
          const targetFileArr = zip.filter((relativePath, file) => { return relativePath === xmlFileName || relativePath === `\\${xmlFileName}` })
          if (targetFileArr && targetFileArr.length) {
            JsZip.file(targetFileArr[0].name).async('text').then((content) => {
              const x2js = new X2JS()
              const jsonObj = x2js.xml2js(content)
              resolve(jsonObj.Root || {})
            })
          } else {
            console.log(`构件缺少 ${xmlFileName} 文件`)
            Message.error('构件解析失败')
            resolve({})
          }
        })
      })
    }

    // 解压gmd/gmed/gnbt文件，并解析json文件
    Vue.prototype.$getGmdJson = function (gmd, jsonFileName = 'CustomData/ModuleInfo/meta.json') {
      return new Promise((resolve, reject) => {
        const JsZip = new JSZip()
        JsZip.loadAsync(gmd).then(function (zip) {
          const targetFileArr = zip.filter((relativePath, file) => { return relativePath === jsonFileName || relativePath === `\\${jsonFileName}` })
          if (targetFileArr && targetFileArr.length) {
            JsZip.file(targetFileArr[0].name).async('string').then((content) => {
              const jsonObj = JSON.parse(content)
              resolve(jsonObj || {})
            })
          } else {
            console.log(`文件缺少 ${jsonFileName} 文件`)
            Message.error('文件解析失败')
            resolve({})
          }
        })
      })
    }

    // 解压G平台模型和链接文件，并解析json文件（默认自动识别json中的分类信息）
    Vue.prototype.$getGModelJson = function (gac, suffix, fileName = 'meta.json') {
      return new Promise((resolve, reject) => {
        unZipForJS7z(gac, fileName, true, function (e, reader) {
          const jsonObj = JSON.parse(reader.result)
          const result = { ProjectAppName: (getFileTypes('MODEL', suffix) || [])[0], ProjectAppVersion: getFirstTwoSegmentsOfAppVersion(jsonObj.AppVersion) }
          resolve(result || {})
        }).catch(function (err) {
          console.error('Error:', err)
          console.log(`构件缺少 ${fileName} 文件`)
          const result = { ProjectAppName: (getFileTypes('MODEL', suffix) || [])[0], ProjectAppVersion: '0.44' }
          resolve(result || {})
        })
      })
    }

    // 解压Reivt文件，并解析版本信息
    Vue.prototype.$getRevitJson = function (rfa, suffix, fileName = 'BasicFileInfo') {
      // eslint-disable-next-line no-undef, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        unZipForJS7z(rfa, fileName, false, function (e, reader) {
          let version = getRevitVersionMap(unicode(reader.result.slice(18, 25)))
          if (!version) {
            version = getRevitVersionMap(unicode(reader.result.slice(48, 55)))
          }
          const result = { ProjectAppName: 'Revit', ProjectAppVersion: version }
          resolve(result || {})
        }).catch(function (err) {
          console.error('Error:', err)
          console.log(`构件缺少 ${fileName} 文件`)
          resolve({})
        })
      })
    }

    // 截取 4位 版本号的前两位例如：0.44.0.0 => 0.44
    function getFirstTwoSegmentsOfAppVersion(appVersion) {
      const segments = appVersion.split('.')
      return segments.length >= 2 ? segments.slice(0, 2).join('.') : null
    }

    const unZipForJS7z = async function (file, fileName, hasDir, func) {
      // eslint-disable-next-line no-undef
      await JS7z({
        print: console.log,
        printErr: console.log,
        onAbort: console.log,
        onExit: console.log
      }).then(async function (js7z) {
        js7z.FS.mkdir('/in')
        const arrayBuffer = await file.arrayBuffer()
        js7z.FS.writeFile('/in/' + file.name, new Uint8Array(arrayBuffer))
        const filesToExtracts = []
        if (hasDir) {
          js7z.callMain(['x', '/in/' + file.name])
          const dirNames = ['dev', 'home', 'in', 'proc', 'tmp']
          for (const p in js7z.FS.lookupPath('/in/').node.parent.contents) {
            if (!dirNames.includes(p)) {
              filesToExtracts.push(p + '/' + fileName)
              break
            }
          }
        } else {
          filesToExtracts.push(fileName)
          js7z.callMain(['x', '/in/' + file.name, ...filesToExtracts])
        }
        filesToExtracts.forEach((fileToExtract) => {
          const array = js7z.FS.readFile(fileToExtract)
          const blob = new Blob([array])
          // 将 Blob对象 读成字符串
          const reader = new FileReader()
          reader.readAsText(blob, 'utf-8')
          reader.onload = function(e) {
            func(e, reader)
          }
        })
      })
    }

    const unicode = function (data) {
      if (data === '') return ''
      return encodeURIComponent(data).replaceAll('%00', '')
    }

    // 解压dwg文件，并解析版本信息
    Vue.prototype.$getCADJson = function (dwg, suffix) {
      return new Promise((resolve, reject) => {
        try {
          var blob = new Blob([dwg])
          // 将 Blob对象 读成字符串
          var reader = new FileReader()
          reader.readAsText(blob, 'utf-8')
          reader.onload = function (e) {
            let version = null
            if (suffix === 'dwg') {
              version = getCADVersionMap(reader.result.slice(0, 6))
            } else {
              // dxf文件
              const dxfParser = new DxfParser()
              const file = dxfParser.parse(reader.result)
              version = getCADVersionMap(file.header.$ACADVER)
            }
            const result = { ProjectAppName: 'AutoCAD', ProjectAppVersion: version }
            resolve(result || {})
          }
        } catch (err) {
          console.error('Error:', err)
          Message.error('构件解析失败')
          resolve({})
        }
      })
    }

    // 生成csv文件
    Vue.prototype.$createCsv = function (csvData, fileName) {
      const utf = '\uFEFF' // 防止中文乱码
      const blob = new Blob([utf + csvData], { type: 'text/csv' })
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // 兼容edge
        navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        // 生成带有当前域名的标准blob:链接
        const url = window.URL.createObjectURL(blob)
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download = fileName
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      }
    }
  }
}
